import { motion } from "framer-motion";
import { RevealOnScroll } from "./Reveal";
import SectionLabel from "./SectionLabel";

const CHAPTERS = [
  {
    n: "01",
    title: "Global Reach.",
    body: "From Stuttgart to Shanghai, Rotterdam to Yokohama — Maklan operates quiet corridors that carry the world's finest products to the African continent with certainty.",
  },
  {
    n: "02",
    title: "Uncompromising Trust.",
    body: "Every manufacturer is chosen. Every shipment is accompanied. Every promise is kept. Trust, at Maklan, is engineered — never assumed.",
  },
  {
    n: "03",
    title: "African-First Thinking.",
    body: "We source, specify and deliver around the realities of Africa — climate, terrain, roads, ports and expectations. The result is a house of goods that finally feels made for the continent.",
  },
  {
    n: "04",
    title: "A Standard That Endures.",
    body: "We build for the next decade, not the next quarter. Longevity — of relationship, of product, of reputation — is the only standard we recognise.",
  },
];

export default function ManifestoChapters() {
  return (
    <section data-testid="manifesto-section" className="section-y-lg bg-ink border-t border-white/5">
      <div className="container-editorial grid grid-cols-12 gap-8 md:gap-16">
        {/* Sticky left column */}
        <div className="col-span-12 md:col-span-5 lg:col-span-4 md:sticky md:top-32 md:self-start">
          <motion.span
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
            className="block h-px bg-[#C5A059] w-14 mb-8 origin-left"
          />
          <div className="overline text-[#C5A059] mb-6">The Manifesto</div>
          <RevealOnScroll
            element="h2"
            className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight"
            lines={["A quiet standard,", "<em>applied to everything</em>."]}
          />
          <p className="editorial-body mt-8 max-w-md">
            Four principles guide every decision — from the manufacturers we choose
            to the containers we route to the after-sales we build.
          </p>
        </div>

        {/* Right column: numbered chapters */}
        <div className="col-span-12 md:col-span-7 lg:col-start-6 space-y-16 md:space-y-20">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 1.2, delay: i * 0.08, ease: [0.19, 1, 0.22, 1] }}
              className="grid grid-cols-12 gap-6 items-start pb-14 border-b border-white/10 last:border-b-0 last:pb-0"
            >
              <div className="col-span-3 md:col-span-2">
                <span className="font-display text-6xl md:text-7xl text-[#C5A059] leading-none">
                  {c.n}
                </span>
              </div>
              <div className="col-span-9 md:col-span-10">
                <h3 className="font-display text-3xl md:text-4xl mb-4 leading-tight">{c.title}</h3>
                <p className="editorial-body max-w-xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
